import React, { useCallback, useState, useEffect} from 'react';
import {
  Container,
  TextField,
  Card,
  Box,
  Switch,
  FormControlLabel,
} from '@material-ui/core';
import {  Lang, Save, StyledButton } from 'components';
import { useText, useGetData, usePutData, usePostData } from 'hooks';
import useStore from 'context';
import * as Api from 'service/index';
import { checkAllFields } from 'helpers/throwErrorEmptiField';
import { useTranslation } from 'localization/translation';
import Button from "@material-ui/core/Button";
import { GetUniqueId } from 'helpers/getUniqueId';
import { BUTTONS_TYPE, requestMessages, HTTP_REQUEST_STATUS } from "Constants";

const initForm = {
  text_en: '',
  text_ru: '',
  text_hy: '',
  title_en: '',
  title_ru: '',
  title_hy: '',
  secondary_title_en: '',
  secondary_title_ru: '',
  secondary_title_hy: '',
  app_store: '',
  play_market: '',
};

const initSliderItem = {
  is_video: true,
  media_link_hy: '',
  media_link_en: '',
  media_link_ru: '',
}

const Slider2 = () => {
  const [sliderItems, setSliderItems] = useState([]);
  const [changedSliderItems, setChangedSliderItems] = useState([]);
  const [data, loading, refresh] = useGetData(Api.v2slider.getAll);
  const updateCallback = usePutData(Api.v2slider.update, refresh);
  const createSliderItems = usePostData(Api.v2sliderItems.create, refresh);
  const updateSliderItems = usePutData(Api.v2sliderItems.update, refresh);

  const { setErrorMsg, lang, setRemove } = useStore();
  const translation = useTranslation();

  const [text, setText, textChange, input] = useText(data || initForm);

  useEffect(() => {
    if(data && data.items) {
      setSliderItems(data.items || [])
    }
  }, [data])

  const submitForm = useCallback(
    async (e) => {
      e.preventDefault();
      checkAllFields(text, setErrorMsg, updateCallback);
    },
    [text, setErrorMsg, updateCallback]
  );

  const checkAllItemIsFill = () => {
    if(sliderItems.length === 0) {
      return true;
    }
    let isAllFill = true;
    sliderItems.forEach((item) => {
      if(!item.media_link_hy || !item.media_link_en || !item.media_link_ru) {
        isAllFill = false;
      }
    })
    return isAllFill;
  }

  const handleAddNewSliderItem = () => {
    if(checkAllItemIsFill()) {
      const newItem = {
        ...initSliderItem,
        id: GetUniqueId(),
        type: 'new'
      };
      setSliderItems([
        ...sliderItems,
        newItem
      ]);
      setChangedSliderItems([...changedSliderItems, newItem]);
    }
  }

  const handleChangeSliderItem = (id, key, value) => {
    const updatedSliderItems = sliderItems.map(item => {
      if(item.id === id) {
        return {
          ...item,
          [key]: value,
        }
      }
      return item;
    });

    setSliderItems(updatedSliderItems);

    setChangedSliderItems(prevChangedItems => {
      const itemToUpdate = updatedSliderItems.find(item => item.id === id);
      const existingChangedItemIndex = prevChangedItems.findIndex(item => item.id === id);
      if (existingChangedItemIndex !== -1) {
        return prevChangedItems.map((item, index) => {
          if (index === existingChangedItemIndex) {
            return itemToUpdate;
          }
          return item;
        });
      } else if (itemToUpdate) {
        return [...prevChangedItems, itemToUpdate];
      }

      return prevChangedItems;
    });
  }

  const deleteSliderItem = (itemId) => {
    setChangedSliderItems(prevChangedItems => prevChangedItems.filter(item => item.id !== itemId));
    setRemove(() => () =>
      Api.main
        .deleteV2sliderItems(itemId)
        .then(() => {
          refresh();
        })
        .catch((err) => {
          if (err.status === HTTP_REQUEST_STATUS.BAD_REQUEST) {
            setErrorMsg(err.message);
          } else {
            setErrorMsg(requestMessages.something_went_wrong);
          }
        })
    );
  }

  const submitSliderForm = (e) => {
    e.preventDefault();

    const newItems = [];
    const changedExistingItems = [];

    changedSliderItems.forEach(item => {
      if(item.type === 'new') {
        const { id, type, ...newItemData } = item;
        newItems.push(newItemData);
      } else {
        changedExistingItems.push(item);
      }
    })

    if(changedExistingItems.length) {
      updateSliderItems(changedExistingItems);
    }
    
    if(newItems.length) {
      createSliderItems(newItems)
    }
    setChangedSliderItems([]);
  }

  const submitSliderForm2 = () => {
    const newItems = [];
    const oldItems = [];
    sliderItems.forEach(item => {
      if(item.type === 'new') {
        newItems.push({
          is_video: item.is_video,
          media_link_hy: item.media_link_hy,
          media_link_en: item.media_link_en,
          media_link_ru: item.media_link_ru,
        });
      } else {
        oldItems.push(item);
      }
    })
    updateSliderItems(oldItems);
    if(newItems.length) {
      createSliderItems(newItems)
    }
  }

  return (
    <Container>
      <Card className="shadow-xxl px-4 py-2">
        <Box component="form" onSubmit={submitForm}>
          <Lang />
          <TextField {...input(`text_${lang}`)} multiline label={translation.text} />
          <TextField {...input(`title_${lang}`)} label={translation.title} />
          <TextField {...input(`secondary_title_${lang}`)} label={translation.secondary} />
          <TextField {...input(`play_market`)} label={translation.play_market} />
          <TextField {...input(`app_store`)} label={translation.app_store} />
          <Save />
        </Box>
      </Card>
      <Card className="shadow-xxl mt-4 px-4 py-2">
        <Box className='align-create-btn-between'>
          <h3>{translation.slider_items}</h3>
          {
            checkAllItemIsFill() && (
              <Button
                className="m-2 btn-neutral-primary"
                onClick={handleAddNewSliderItem}
              >
                {translation.add}
              </Button>
            )
          }
        </Box>
        <Box
          component="form"
          onSubmit={submitSliderForm}
          className='pb-4'
        >
          {
            sliderItems?.map((item, index) => {
              return (
                <Card key={index.toString()} className='shadow-xxl mt-4 px-4 py-4 pb-8'>
                  <div className='mb-2 align-create-btn-between'>
                    <FormControlLabel
                      control={
                        <div className="m-2">
                          <Switch
                            onClick={(e) => handleChangeSliderItem(item.id, 'is_video', e.target.checked)}
                            checked={item.is_video}
                            className="switch-medium toggle-switch-first"
                          />
                        </div>
                      }
                      label={item.is_video ? translation.video_link : translation.image_link}
                    />
                    <div className="delete_filed">
                      <StyledButton
                        className={BUTTONS_TYPE.delete}
                        name={translation.delete}
                        onClick={() => deleteSliderItem(item.id)}
                      />
                    </div>
                  </div>
                  <Lang />
                  <TextField
                    value={item[`media_link_${lang}`]}
                    multiline 
                    label={item.is_video ? translation.video_link : translation.image_link}
                    onChange={(e) => handleChangeSliderItem(item.id, `media_link_${lang}`, e.target.value)}
                    className='w-100 mb-2'
                  />
                </Card>
              )
            })
          }
          {
            !!sliderItems.length && checkAllItemIsFill() && (
              <Save />
            )
          }
        </Box>
      </Card>
    </Container>
  );
};

export default Slider2;
